import { Squire } from './Editor';

(window as any).Squire = Squire;
